import React from "react"

import Layout from "../components/layout/layout.component"
import SEO from "../components/seo/seo.component"
import Form from "../components/form/form.component"

export default () => (
  <Layout>
    <SEO title="RSVP | KatieJo Turns 1" />
    <Form />
  </Layout>
)
